const template=`
<div class="widget-container searchListWidgetContainer jqSearchListWidgetContainer">
  <div class="commonCollection">
    <div class="searchListWidget">
      <widget-status></widget-status><span ng-hide="searchIsLoading || !widget.hasRequiredSettings()">
        <core-content-stream type="contentStreamType"></core-content-stream></span>
    </div>
  </div>
</div>`;
export default template;
